/* Petifo · Menu products — clones the server-rendered product rail into the
   bottom of the mobile menu drawer.

   Why an external asset + polling: a <script> inline in a header-group section
   (and {% javascript %}) does NOT run reliably there, and the drawer renders
   lazily, so a one-shot run misses it. This file is loaded normally, then polls
   + observes until the drawer exists. It is idempotent (skips when already
   injected) so it can run as often as it likes. */
(function () {
  'use strict';

  var TEMPLATE = '[data-pf-mp-template]';
  var INJECTED = 'pf-mp--injected';
  var cloneIndex = 0;

  function wireQuickAdd(root) {
    // Release the menu's focus/scroll trap before the native chooser or cart opens.
    root.addEventListener('click', function (event) {
      var button = event.target.closest('.quick-add__button');
      var header = root.closest('header-drawer');
      var details = header && header.querySelector('.menu-drawer-container');
      if (!button || button.disabled || !details || !details.open || typeof header.close !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (root.dataset.quickAddPending === 'true') return;
      root.dataset.quickAddPending = 'true';
      var observer = new MutationObserver(function () {
        if (details.open) return;
        observer.disconnect();
        delete root.dataset.quickAddPending;
        if (button.isConnected) button.click();
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      header.close();
    }, true);
  }

  function wireArrow(root) {
    var rail = root.querySelector('[data-pf-mp-rail]');
    var arrow = root.querySelector('.pf-mp__arrow');
    if (!rail || !arrow) return;

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 4;
      var atEnd = rail.scrollLeft >= max;
      var noOverflow = rail.scrollWidth <= rail.clientWidth + 4;
      root.classList.toggle('pf-mp--end', atEnd || noOverflow);
    }

    arrow.addEventListener('click', function () {
      rail.scrollBy({ left: Math.round(rail.clientWidth * 0.8), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });

    try {
      new ResizeObserver(update).observe(rail);
    } catch (e) {}

    update();
    setTimeout(update, 400);
  }

  function inject() {
    var tpl = document.querySelector(TEMPLATE);
    if (!tpl) return false;

    var drawers = document.querySelectorAll('.menu-drawer');
    if (!drawers.length) return false;

    var done = false;
    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];
      if (drawer.querySelector('.' + INJECTED)) { done = true; continue; }

      var clone = tpl.content.firstElementChild.cloneNode(true);
      var suffix = '-Menu-' + (++cloneIndex);
      clone.querySelectorAll('form[id]').forEach(function (form) {
        form.setAttribute('id', form.getAttribute('id') + suffix);
      });
      clone.classList.add(INJECTED);
      wireQuickAdd(clone);
      drawer.appendChild(clone);
      wireArrow(clone);
      done = true;
    }
    return done;
  }

  function start() {
    inject();

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (inject() || tries > 60) clearInterval(iv);
    }, 500);

    var scheduled = false;
    try {
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () { scheduled = false; inject(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
